import {
  handleFieldsOnKeyup,
  handleInputsDate,
  hideColumn,
  transformSpanIntoInput,
  handleTdHidden,
  setInfinityOnChange,
  switchBetweenInputs,
} from "./tabs";

import {
  updateFieldsAjax,
  resetFieldsAjax,
  handleTotalLine,
  calculateColumn,
  getShareAndFaiValues,
  sumShareValue,
  handleAddFieldsButton,
  handleSubmitButton,
} from "./shared/investment_helper";

$(function () {
  $(".o-js-field").on("change", function () {
    updateFieldsAjax($(this));
  });
  handleTotalLine($(".o-js-total-table"));
  $(".o-js-total-table thead th").each(function () {
    if ($(this).hasClass("is-summable")) {
      calculateColumn($(this).index());
    }
  });
  hideColumn($(".o-js-total-hidden-column"));
  handleFieldsOnKeyup();
  transformSpanIntoInput();
  handleTdHidden();
  resetFieldsAjax();
  setInfinityOnChange();
  handleInputsDate();
  if ($(".o-js-investment_funds_cocoon_wrapper").length) {
    let selectFund = $(".o-js-select_fund");
    let missingFundError = $(".o-js-missing_fund_error");
    var result;

    $(".o-js-investment_funds_cocoon_wrapper").on(
      "cocoon:before-insert",
      function (e, insertedItem) {
        let selectedFund = selectFund.val();
        let fields = insertedItem.find(".o-js-field");

        if (selectedFund == "") {
          e.preventDefault();
          missingFundError.show();
        } else {
          missingFundError.hide();

          $.ajax({
            url: "/investment_funds/calculate.json?fund_id=" + selectedFund,
            type: "GET",
            success: function (response) {
              result = response.data.result;
              $.each(result, function (key, valueObj) {
                fields.each(function () {
                  if (key == $(this).data("type")) {
                    if ($(this).is("p")) {
                      $(this).text(valueObj);
                    } else {
                      $(this).val(valueObj);
                      $(this).data("default", valueObj);
                    }
                  }
                });
              });
              handleTotalLine($(".o-js-total-table"));
              handleAddFieldsButton(response.data.user);
              handleSubmitButton();
              handleFieldsOnKeyup();
              transformSpanIntoInput();
              setInfinityOnChange();
              switchBetweenInputs();
              handleInputsDate();
              $(".o-js-total-table thead th").each(function (i) {
                if ($(this).hasClass("is-summable")) {
                  calculateColumn($(this).index());
                }
              });
              hideColumn($(".o-js-total-table"));
              $(".o-js-big-loader").removeClass("is-visible");
            },
            beforeSend: function () {
              $(".o-js-big-loader").addClass("is-visible");
            },
          });
          handleTdHidden();
        }
      },
    );

    $(".o-js-investment_funds_cocoon_wrapper").on(
      "cocoon:after-insert",
      function () {
        $(".o-js-field").on("change", function () {
          updateFieldsAjax($(this));
        });
        resetFieldsAjax();
        handleTotalLine($(".o-js-total-table"));
        $(".o-js-total-table thead th").each(function (i) {
          if ($(this).hasClass("is-summable")) {
            calculateColumn($(this).index());
          }
        });
        handleTdHidden();
      },
    );

    $(".o-js-investment_funds_cocoon_wrapper").on(
      "cocoon:after-remove",
      function () {
        $(".o-js-total-table thead th").each(function (i) {
          if ($(this).hasClass("is-summable")) {
            calculateColumn($(this).index());
          }
        });
        handleAddFieldsButton(false);
        handleSubmitButton();
        getShareAndFaiValues();
        sumShareValue();
        handleTotalLine($(".o-js-total-table"));
      },
    );

    $(document).on("click", ".o-js-save_session", function (e) {
      e.preventDefault();

      let form = $("#new_investment");

      form.submit();
    });
  }
});
